import { compare, email, password, prop, required } from '@rxweb/reactive-form-validators';

export class UserModel {
	@required()
	name: string;

	@required()
	@email()
	email: string;

	@required()
	password: string;
	
	@required()
	@compare({ fieldName: 'password' })
	confirmPassword: string;

	@required()
	rolName: string;
	@required()
	client_id: any;

}
